@if (dynamicItems().length > 0) {
<epc-dynamic-collections-renderer
  [items]="dynamicItems()"
  [scope]="scope"
  class="d-contents"
>
</epc-dynamic-collections-renderer>
}
